import { Subject } from 'rxjs';

export class ResearchScreenConfigs {
    actionSubject$: Subject<ResearchScreenConfigAction>;
    constructor(
        public screenKey: string,
        public embedMode: boolean = false,
        public searchText = '',
        public advFilter = '',
        public refinebyCategory: Array<string> = null,
        public showCalendarEvents = false,
    ) {
        this.actionSubject$ = new Subject<ResearchScreenConfigAction>();
    }
}

export class ResearchScreenConfigAction {
    constructor(public type: ResearchScreenConfigActionType, public payload: any) {
    }
}

export enum ResearchScreenConfigActionType {
    Filter = 'Filter',
    Reinitialize = 'Reinitialize',
    FOCUS_ON_ROW = 'FOCUS_ON_ROW',
    TAB_CLICK = 'TAB_CLICK',
    PRINT = 'PRINT',
    FOCUS_FINDER = 'FOCUS_FINDER',
}

export enum ResearchScreenSubComponents {
    KEYWORD = 'KEYWORD',
    RELATIONSHIP_TREE = 'RELATIONSHIP_TREE'
}
